module.exports = __webpack_public_path__ + "static/media/pamain-bold.5dbd94aa.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pamain-bold.woff
// module id = ./src/assets/fonts/pamain-bold.woff
// module chunks = 6